import type { ReactNode } from 'react';
import { Flex, HStack, type BoxProps } from '../Core';
import { Icon, ICON_SIZES, IconName } from '../Icons';
import { Tab, TabAppearance, TabButton, TabList, Tabs, TabSize } from '../Tabs';

export interface TabbedDrawerHeaderProps extends Omit<BoxProps, 'title'> {
  title?: string;
  actions?: ReactNode;
  onClose: () => void;
  titleTestId?: string;
  closeButtonTestId?: string;
}

export function TabbedDrawerHeader({
  title,
  actions,
  onClose,
  titleTestId,
  closeButtonTestId = 'drawer-close-button',
  ...boxProps
}: TabbedDrawerHeaderProps) {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="backgroundBody"
      background="backgroundFilledTabList"
      {...boxProps}
    >
      <Tabs appearance={TabAppearance.Filled} size={TabSize.Small} selectedIndex={0}>
        <TabList>
          <Tab label={title} data-testid={titleTestId} />
        </TabList>
      </Tabs>
      <HStack>
        {actions}
        <TabButton
          size={TabSize.Small}
          onClick={onClose}
          suffix={<Icon icon={IconName.Close} size={ICON_SIZES.SMALL} />}
          appearance={TabAppearance.Filled}
          aria-label="Close drawer"
          data-testid={closeButtonTestId}
        />
      </HStack>
    </Flex>
  );
}
